export function memberGuid(row) {
  if (!row) return null
  const key = row.userguid ?? row.clientmemberguid ?? row.id
  return key != null ? String(key) : null
}

export function normalizeMember(row) {
  const id = memberGuid(row)
  return id ? { ...row, id } : { ...row }
}
